import { useDictionary } from "contexts/Dictionary"
import { useWishlist } from "contexts/Wishlist"
import { useEffect, useState } from "react"

import { AriaHelper, Button, WishlistIcon, NewModel, Root } from "./style"

const WishlistButton = props => {
  const { rmc, family, icon = "wishlist", withLabel, modelName, className, newmodelselection, aria_describedby, cfg_embed } = props

  const { toggleWishlist, isInWishlist, wishlistUpdateIndex, wishlist, notificationRMC } = useWishlist()
  const dictionary = useDictionary()

  const [heart, setHeart] = useState(null)
  const [ariaLive, setAriaLive] = useState(null)

  useEffect(() => {
    if (wishlist === null) return
    setHeart(isInWishlist(rmc))
  }, [wishlistUpdateIndex, rmc, family, wishlist])

  const resolveIcon = () => {
    switch (icon) {
      case "wishlist":
        return heart ? "heartFull" : "heart"
      default:
        return icon
    }
  }

  const isWatch = notificationRMC?.rmc?.startsWith("m")
  const displayToggleLabelAddTitle =
    isWatch && notificationRMC?.action === "add" ? dictionary.headerWishlistWatchAddedTitle() : dictionary.headerWishlistAccessoriesAddedTitle()
  const displayToggleLabelRemoveTitle =
    isWatch && notificationRMC?.action === "remove" ? dictionary.headerWishlistWatchRemovedTitle() : dictionary.headerWishlistAccessoriesRemovedTitle()

  const handleButtonClick = () => {
    if (!isInWishlist(rmc)) {
      setAriaLive(`${displayToggleLabelAddTitle} - ${modelName}`)
    } else {
      setAriaLive(`${displayToggleLabelRemoveTitle} - ${modelName}`)
    }
    setTimeout(() => {
      setAriaLive(null)
    }, 3000)
    toggleWishlist(rmc, family, cfg_embed)
  }

  return (
    <Root className='wishlist-button-root'>
      {newmodelselection ? <NewModel className='newmodel'>{dictionary.newModel()}</NewModel> : <div className='placeholder' />}
      <Button
        className={className || "wishlist-button"}
        heart={heart}
        onClick={() => handleButtonClick()}
        aria-describedby={aria_describedby}
        aria-label={!heart ? `${modelName || ""} - ${dictionary.wishlistAriaLabelAdd()}` : `${modelName || ""} - ${dictionary.wishlistAriaLabelRemove()}`}
      >
        <WishlistIcon type={resolveIcon()} style={{ fill: icon === "close" ? "rgb(var(--dark-grey))" : null }} />

        <AriaHelper>
          <div aria-live='polite'>{ariaLive}</div>
        </AriaHelper>
        {withLabel && <span>{!heart ? dictionary.wishlistAdd() : dictionary.wishlistRemove()}</span>}
      </Button>
    </Root>
  )
}

export default WishlistButton
